/** Component to input an airport, or display an existing airport.
 * As input, it takes the existing selection, and and airport by iata lookup map.
 * During user interaction, new airports may be 'discovered' which are optionally
 * relayed to the parent component.
 */

import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { Map, List } from "immutable";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { findAirportsByName } from "../api";
// See: http://ericgio.github.io/react-bootstrap-typeahead/#asynchronous-searching
import { setLabel } from "../airport/airportUtils";
import { setLabelWithQuery } from "../airport/airportUtils";

class AirportInput extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      options: [],
      selected: undefined
    };
  }

  // resetValue(e)
  // {
  //   console.log(this.props.iataCode)
  //   console.log(e)
  //   e.target.value = this.props.iataCode
  //       ? setLabel(this.props.airportByIata
  //           .get(this.props.iataCode, Map.of('label', this.props.iataCode)))
  //           .toJS()
  //       : ''
  // }

  render() {
    const { iataCode, airportByIata = Map(), className, placeholder } = this.props;

    const { isLoading, options } = this.state;
    // return <input
    //     className={className}
    //     placeholder={placeholder}
    //     type="text"
    //     onChange={this.onChange.bind(this)}
    //     value={airportNameLocByIata(iataCode, airportByIata)} />

    // Styling problem: Probably because we have an invisible input inside a virtual input,
    // in order to support a "tags" type of interface.

    return (
      <AsyncTypeahead
        id={this.props.id}
        onFocus={e => e.target && e.target.select()}
        useCache={false}
        className={className}
        isLoading={isLoading}
        options={options}
        labelKey="label"
        selected={iataCode ? [setLabel(airportByIata.get(iataCode)).toJS()] : []}
        // defaultSelected= { [setLabel(airportByIata.get(iataCode)).toJS()]}
        minLength={2}
        onSearch={this.onSearch.bind(this)}
        placeholder={placeholder}
        renderMenuItemChildren={(airport = {}) => (
          <div className="airport">
            <div className="name">{airport.name}</div>
            <div className="location">
              {airport.city}, {airport.country}
            </div>
          </div>
        )}
        onChange={this.onChange.bind(this)}
      />
    );
  }

  onSearch(query) {
    this.setState({
      isLoading: true
    });
    findAirportsByName(query).then((airports = List()) => {
      // Relay newly-discovered airports to parent
      if (this.props.onNewAirports) {
        this.props.onNewAirports(airports);
      }

      // Add the query to the label used by AsyncTypeahead to filter display options
      // because queries that were fuzzy matched or aliases were being filtered out.
      this.setState({
        options: airports.map(setLabelWithQuery(query)).toJS(),
        isLoading: false
      });
    });
  }

  onChange([airport = {}]) {
    const { iataCode, onChange } = this.props;
    if (airport.iataCode && airport.iataCode !== iataCode) {
        onChange(airport.iataCode);
    } else {
        onChange(undefined);
    }
  }
}

AirportInput.propTypes = {
  iataCode: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  // One or more new airports are discovered.
  // :: Seq<Map> -> ()
  onNewAirports: PropTypes.func,
  airportByIata: ImmutablePropTypes.map,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
};

export default AirportInput;



// WEBPACK FOOTER //
// ./src/ndc/request/AirportInput.js